import React from "react"
import {useDispatch, useSelector} from "react-redux"
import "./products-filters-dropdown.scss"
import {updateSortByValue} from "redux/actions"

const ProductsFiltersDropdown = () => {
  const dispatch = useDispatch()
  const {filterOptionList, sortByValue} = useSelector(({product}) => product)
  const sortByOption = filterOptionList?.sort_by_section
    ?.filter(option => option.is_visible === "1")
    ?.map(limit => ({title: limit.title, value: limit.sort_id})) ?? []

  return (
    <>
      <div className="filter-items-dropdown">
        <label>Sort By</label>
        <select
          value={sortByValue}
          onChange={e => dispatch(updateSortByValue(e.target.value))}
        >
          {sortByOption?.map(option => (
            <option key={option.value} value={option.value}>
              {option.title}
            </option>
          ))}
        </select>
      </div>
    </>
  )
}

export default ProductsFiltersDropdown
